import React from "react";

import IconButton from "@replo/design-system/components/button/IconButton";
import {
  Card,
  CardContent,
} from "@replo/design-system/components/shadcn/core/card";
import { CircleX } from "lucide-react";

const CanceledCard = () => {
  return (
    <Card className="w-full max-w-[400px] p-0 mb-3">
      <CardContent className="flex flex-col items-start gap-2 p-4">
        <div className="flex flex-row gap-3 items-start w-full">
          <IconButton
            variant="secondary"
            UNSAFE_className="bg-neutral-soft border-border"
            icon={<CircleX size={16} className="text-muted" />}
          />
          <div className="flex-1 flex flex-col gap-1">
            <div className="text-base font-semibold">Request canceled</div>
            <p className="text-sm text-muted relative">
              You canceled this request. No further changes will be made.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CanceledCard;
